import { DS_getData, type DS_TData } from '../DS/DS.Data'

export type I18N_ISlugsDict = { [slug: string]: string }

export function I18N_replaceSlug(text: string, d?: DS_TData) {
    d = d || DS_getData()
    const translation = d.slugs[text]
    return translation != null ? translation : text
}

export function I18N_replaceNameSlug<T extends { name: string }>(entity: T): T {
    return { ...entity, name: I18N_replaceSlug(entity.name) }
}

export function I18N_replaceNameSlugs<T extends { name: string }>(entities: T[]): T[] {
    return entities.map(I18N_replaceNameSlug)
}
